<template>
    <emc-card-stats
            icon="mdi-flask-outline"
            color="blue darken-4"
            sheet-width="50"
            sheet-heigth="50"
            icon-class="px-3 py-1"
            :subtitle="subtitle"
            :tools="!hideFooter"
            :classSubTitle="classSubTitle"
            >

          <template slot="tools">
              
            <emc-button-icon v-if="!type" :loading="loading" icon="mdi-refresh-circle" text="Atualizar" color="success" @click.prevent.stop="refresh()" />

              <v-tooltip v-if="showMoreButton" bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" color="primary" v-on="on" icon @click="$emit('showMoreAmbiences', itemId)">
                        <v-icon btn>mdi-monitor-eye</v-icon>
                    </v-btn>
                </template>
                <span>
                    Ver Mais...
                </span>
            </v-tooltip>
              <v-tooltip v-if="!hideTools" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="indigo darken-1" icon small @click.prevent.stop="download(12)" v-bind="attrs" v-on="on"><v-icon>mdi-microsoft-excel</v-icon></v-btn>
                  </template>
                  <span>Horários</span>
              </v-tooltip>
          </template>
          <template slot="body">
            <v-progress-circular
                          :rotate="360"
                          :size="140"
                          :width="15"
                          :value="ambience && ambience.percent ? ambience.percent : 0"
                          color="blue darken-4"
                        >
                        <template slot:default>
                          <span>
                            <span>{{ ambience && ambience.percent ? ambience.percent : 0}}%</span><br />
                            <span v-if="ambience && ambience.total">{{ ambience.completed}} / {{ ambience.total}}</span>
                          </span>
                        </template>
                      </v-progress-circular>
          </template>
          </emc-card-stats>
</template>

<script>

import { mapActions, mapState } from 'vuex'
import  { myMixin } from '../../../mixins';

export default {
    name: 'EmcChartAmbienceOfWorkTime',
    mixins: [myMixin],
    data () {
        return {
          loading: false,
          ambience: {
            total: 0,
            percent: 0,
            completed: 0
          }
        }
    },
    methods: {
      ...mapActions('controlPanel', ['ActionFindIndicatorAmbiences', 'ActionIndicatorAmbiencesRefresh']),
      
      getData(){
      
        this.ambience = this.indicator;
        
        if(this.type == 'campus' || this.type == 'institution'){
          return;
        }
        
        var payload = {
            work_time_id: this.acesso.periodo.id
        };
        
        this.ActionFindIndicatorAmbiences(payload)
          .then((res) => {
              this.ambience = res.data;
          })
          .finally(() => {
            this.loading = false;
          });
      
      },
      refresh(){
      
        this.loading = true;
        
        this.ActionIndicatorAmbiencesRefresh()
            .then((res) => {
                
            })
            .finally(() => {
              setTimeout(() => {  
                this.getData();
              }, 6000);
            });
      },
    },
    props: {
        hideTools: {
            type: Boolean,
            default: false
        },
        hideFooter: {
            type: Boolean,
            default: false
        },
        type: {
          type: String,
          default: null,
        },
        indicator: {
          default: null,
        },
        itemId: {
            type: Number,
            default: null
        },
        showMoreButton: {
            type: Boolean,
            default: false
        },
        subtitle: {
          type: String,
          default: 'Ambiente',
        },
        hideSubText: {
          type: Boolean,
          default: false
        },
        classSubTitle: {
          type: String,
          default: 'text-h5 font-weight-light grey--text'
        }
    },
    created() {
      this.getData()
    },
    computed: {
      ...mapState('auth', ['acesso']),
    }
}
</script>